import CampaignIcon from '@mui/icons-material/Campaign'
import { MUIButton } from 'components/common/MUIButton'

interface CreateRequestButtonProps {
  disabled: boolean
  onCreateRequest: () => void
  labelText: string
}

export const CreateRequestButton = ({
  disabled,
  onCreateRequest,
  labelText,
}: CreateRequestButtonProps) => {
  return (
    <MUIButton
      size="sm"
      type="secondaryNoBorder"
      startIcon={<CampaignIcon />}
      disabled={disabled}
      onClick={() => !disabled && onCreateRequest()}
    >
      {labelText}
    </MUIButton>
  )
}
